import metrics from 'maps/metrics';

export default getTableHeaders;

function getTableHeaders(spinsType) {
  const defaults = [metrics['countThisWeekToDate'], metrics['countLastWeek']];

  switch (spinsType) {
    case 'countries':
      return [
        { label: 'country', value: 'countryName' },
        ...defaults,
        { label: 'expand', value: 'expand' },
      ];
    case 'markets':
      return [
        { label: 'market', value: 'marketName' },
        ...defaults,
        { label: 'expand', value: 'expand' },
      ];
    case 'stations':
    default:
      return [
        { label: 'radio station', value: 'stationName' },
        { label: 'country', value: 'countryName' },
        { label: 'state', value: 'stateName' },
        { label: 'market', value: 'marketName' },
        { label: 'format', value: 'formatName' },
        ...defaults,
      ];
  }
}
